import { z } from 'zod'
import { useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from '@/components/shadcn/form'
import { Input } from '@/components/shadcn/input'
import { Button } from '@/components/shadcn/button'
import { Popover, PopoverContent, PopoverTrigger } from '@/components/shadcn/popover'
import { IconEditOutline } from '@icons/IconEditOutline'
import { useState } from 'react'
import { useAppPageLayout } from '@/catalog-apps/components/AppPage2/useAppPageLayout'

const titleDescriptionSchema = z.object({
  title: z.string().optional(),
  description: z.string().optional(),
})

function EditTitleDescriptionForm({ onSubmit }: { onSubmit?: () => void }) {
  const {
    titleDesrcription: { title, description },
    setTitleDesrcription,
  } = useAppPageLayout()

  const form = useForm<z.infer<typeof titleDescriptionSchema>>({
    resolver: zodResolver(titleDescriptionSchema),
    defaultValues: {
      title,
      description,
    },
  })

  const handleSubmit = (data: z.infer<typeof titleDescriptionSchema>) => {
    setTitleDesrcription(data)
    onSubmit?.()
  }

  return (
    <Form {...form}>
      <form className="space-y-2" onSubmit={form.handleSubmit(handleSubmit)}>
        <FormField
          control={form.control}
          name="title"
          render={({ field }) => (
            <FormItem>
              {/* <FormLabel>Title</FormLabel> */}
              <FormControl>
                <Input {...field} placeholder="Title" className="h-7" />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        <FormField
          control={form.control}
          name="description"
          render={({ field }) => (
            <FormItem>
              {/* <FormLabel>Description</FormLabel> */}
              <FormControl>
                <Input {...field} placeholder="Description" className="h-7" />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        <div className="flex justify-end">
          <Button type="submit" variant="outline" size="sm" className="h-6">
            Update
          </Button>
        </div>
      </form>
    </Form>
  )
}

export function EditTitleDescriptionFormPopover() {
  const [open, setOpen] = useState(false)
  const closePopover = () => setOpen(false)
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button variant="ghost" size="icon" className="size-6">
          <IconEditOutline />
        </Button>
      </PopoverTrigger>
      <PopoverContent side="right" portal>
        <EditTitleDescriptionForm onSubmit={closePopover} />
      </PopoverContent>
    </Popover>
  )
}
